import CustomUsecaseForm from "../../components/CustomUsecaseForm/CustomUsecaseForm";
import React, { useEffect } from "react";
import Navbar from "../../components/NavigationMenu/NavBar";
import Footer from "../../components/Footer/Footer";

const ContactUS = () => {
  useEffect(() => {
    // Load the Vapi widget script
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@vapi-ai/client-sdk-react/dist/embed/widget.umd.js';
    script.async = true;
    script.type = 'text/javascript';
    document.body.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      {/* <Navbar /> */}
      <div style={{ marginTop: "100px" }}>
        <CustomUsecaseForm />
      </div>
      {/* <Footer /> */}
      
      {/* Vapi Widget */}
      <vapi-widget
        public-key="f3c1c3fb-e293-441c-9b2a-3e86193aaa5d"
        assistant-id="8678eab5-ed73-4685-951e-6252feb9c2cd"
        mode="voice"
        theme="dark"
        base-bg-color="#000000"
        accent-color="#e95f43"
        cta-button-color="#000000"
        cta-button-text-color="#ffffff"
        border-radius="large"
        size="full"
        position="bottom-right"
        title="PLACE YOUR ORDER"
        start-button-text="Start"
        end-button-text="End Call"
        chat-first-message="Hey, How can I help you today?"
        chat-placeholder="Type your message..."
        voice-show-transcript="true"
        consent-required="true"
        consent-title="Terms and conditions"
        consent-content="By clicking Agree, and each time I interact with this AI agent, I consent to the recording, storage, and sharing of my communications with third-party service providers, and as otherwise described in our Terms of Service."
        consent-storage-key="vapi_widget_consent"
      ></vapi-widget>
    </>
  );
};

export default ContactUS;